if(!customElements.get("sticky-header")) {
  customElements.define("sticky-header", class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    lockIcon() {
      return `
        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="lock" class="svg-inline--fa fa-lock fa-w-14" role="img" viewBox="0 0 448 512">
          <path fill="currentColor" d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"/>
        </svg>
      `;
    }

    connectedCallback() {
      // Header components
      this.staticNav = this.querySelector(".header");
      this.promoBar = this.querySelector(".announcement-bar");
      this.header = this.querySelector('#main-navigation');
      this.headerSection = this.closest("#shopify-section-header");
      this.secureCheckoutPanel = this.querySelector(".secure-checkout__panel");
      this.cartCount = this.querySelector("#cartCount");
      this.cartCountAlt = this.querySelectorAll(".alt__cartCount");

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.onWindowResize = this.onResize.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener("resize", this.onWindowResize, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.headerSection);
    }

    onResize() {
      const pageWidth = window.innerWidth;
      if(pageWidth > 989) {
        requestAnimationFrame(this.reset.bind(this));
      } else {
        requestAnimationFrame(this.resetDesktop.bind(this));
      }
    }

    onScroll() {
      const pageWidth = window.innerWidth;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      const headerHeight = (this.offsetHeight - (this.header.offsetHeight + 12));

      if(pageWidth > 989) {
        if(scrollTop > this.currentScrollTop && scrollTop > headerHeight) {
          requestAnimationFrame(this.revealDesktop.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > headerHeight) {
          requestAnimationFrame(this.revealDesktop.bind(this));
        } else if(scrollTop <= headerHeight) {
          requestAnimationFrame(this.resetDesktop.bind(this));
        }
      } else {
        if(scrollTop > this.currentScrollTop && scrollTop > (this.headerBounds.bottom - this.headerBounds.height)) {
          requestAnimationFrame(this.reveal.bind(this));
        } else if(scrollTop < this.currentScrollTop && scrollTop > (this.headerBounds.bottom - this.headerBounds.height)) {
          requestAnimationFrame(this.reveal.bind(this));
        } else if(scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    revealDesktop() {
      this.header.classList.add('header--sticky', 'animate');
      this.style.height = `${this.promoBar.offsetHeight + this.staticNav.offsetHeight + this.header.offsetHeight}px`;
    }

    resetDesktop() {
      this.header.classList.remove('shopify-section-header-hidden', 'header--sticky', 'animate');
      this.style.height = "unset";
    }

    reveal() {
      this.headerSection.classList.add("shopify-section-header-sticky", "animate");
      this.headerSection.classList.remove("shopify-section-header-hidden");
    }
    reset() {
      this.headerSection.classList.remove("shopify-section-header-hidden", "shopify-section-header-sticky", "animate");
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    renderSecurePanel(cart, threshold) {
      const itemCount = cart.item_count;
      const cartTotal = cart.total_price;

      const secureForm = `
        ${itemCount > 0 ? `
            <form class="top-secure-checkout" action="/checkout" method="post" novalidate>
              <div class="top__shipping-info">
                ${cartTotal < threshold ? `
                    <a href="/collections/all">You're
                    <span class="money">$${parseFloat((threshold - cartTotal) / 100).toFixed(2)}</span>
                    away from free shipping!</a>
                  ` : ""}
              </div>
              <div class="top__btn">
                <button class="secure-checkout-btn" onclick="zonosCheckout(event);">
                  ${this.lockIcon()}
                  Secure Checkout
                </button>
              </div>
            </form>
          ` : ""}
      `;
      this.secureCheckoutPanel.innerHTML = secureForm;
    }
  });
}
